import { useState, useCallback, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import s from './MLTooltip.module.css';

function MLTooltip({
  children,
  content,
  placement = 'bottom',
  interactive = true,
  disabled = false,
  onOpen,
  onClose,
}) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleUserKeyPress = useCallback((event) => {
    const { key } = event;
    if (key === 'Escape') {
      handleClose();
    }
  }, [handleClose]);

  useEffect(() => {
    if (open) {
      window.addEventListener('keydown', handleUserKeyPress);
      return () => {
        window.removeEventListener('keydown', handleUserKeyPress);
      };
    }
  }, [handleUserKeyPress, open]);

  return (
    <Tooltip
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      classes={{
        tooltip: s.tooltip,
        arrow: s.tooltipArrow,
      }}
      title={disabled ? '' : content}
      placement={placement}
      interactive={interactive}
      arrow
    >
      {children}
    </Tooltip>
  );
}

export default MLTooltip;
